import React from 'react';

export default function ProprietarySchoolModalContent() {
  return (
    <>
      <p>
        An institution that is neither a public nor a private nonprofit
        institution. A proprietary institution is generally operated by its
        owners, investors, or shareholders in a manner prioritizing{' '}
        <va-link
          text="shareholder interests."
          href="https://en.wikipedia.org/wiki/Shareholder_primacy"
        />
      </p>
    </>
  );
}
